import { useTranslation } from 'react-i18next';
import PayoutTableItem, { PayoutTableItemProps } from '../PayoutTableItem/PayoutTableItem';
import './PayoutTable.scss';

interface PayoutTableProps {
  header: 'your-current-score' | 'all-players';
  items: PayoutTableItemProps[];
}

const PayoutTable = ({ header, items }: PayoutTableProps) => {
  const { t } = useTranslation();
  return (
    <div className={'payout-table'}>
      <div className={'payout-table__title'}>{t(header)}</div>
      <div className={'payout-table__item-wrapper'}>
        <div className={'payout-table__header'}>
          <div className={'payout-table__header__text'}>{t('payout-table-results')}</div>
          <div className={'payout-table__header__text'}>{t('payout-table-players')}</div>
          <div className={'payout-table__header__text'}>{t('payout-table-prize-pool')}</div>
        </div>
        {items.map((item, index) => {
          return <PayoutTableItem key={index} {...item} />;
        })}
      </div>
    </div>
  );
};

export default PayoutTable;
